import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

export const NoUsersIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <path
        d="M22 9.12121C24.1515 5.78788 27.9091 3.60606 32.1515 3.60606C38.8485 3.60606 44.2727 9.0303 44.2727 15.7273C44.2727 19.9697 42.0909 23.7273 38.7576 25.8788L22 9.12121ZM56.3939 43.5151C56.3333 40.1818 54.4848 37.1212 51.5151 35.5758C49.8788 34.7273 48.0909 33.9394 46.1515 33.2727L56.3939 43.5151ZM60 55.697L4.30303 0L0 4.27273L26.9394 31.2121C21.4545 31.9091 16.6667 33.6061 12.7879 35.6061C9.75758 37.1515 7.90909 40.2727 7.90909 43.6667V52.0909H47.8182L55.7273 60L60 55.697Z"
        fill="#D2E0E8"
      />
    </svg>
  );
};